export const environment = {
    production : false,
    //For Dev
    // baseUrl:'http://10.70.1.101:80/api/'

    //For UAT old
    // baseUrl:'http://10.70.1.102:80/api/'

    //For UAT new
    // baseUrl:'https://ktuatraeez.katmb.com.my/api/api/'

    //For Prod
    baseUrl:'https://mobile.raees.com.my:5724/api/'


};
